
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-app",
      function () {
        return require("private-next-pages/get-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-app"])
      });
    }
  